<template>
    <div class="register-card">
        <div class="wrapper">
            <h3>Registrer bruger</h3>
            <br>
            <form action="/#" method="/post" @submit.prevent="register()">
                <label for="username">
                    Brugernavn:
                </label>
                <input
                    type="text"
                    name="username"
                    placeholder="Brugernavn"
                    v-model="username"
                    />
                <br>
                <label for="password">
                    Password:
                </label>
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    v-model="password"
                    />
                <br>
                <span class="remember">
                    <input type="checkbox" name="remember" v-model="rememberMe" /> Husk mig
                </span>
                <br>
                <button type="submit">
                    Registrer
                </button>
            </form>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .register-card {
        display: flex;
        justify-content: center;
        width: 500px;
        margin: 15vh auto;
        padding: 30px;
    }

    .wrapper {
        display:flex;
        flex-direction: column;
        justify-content: space-around;
        height:250px;
    }

    .remember {
        display: flex;
        justify-content: space-between;
        width: 55%;
    }
    
    button {
        background: #eee;
        padding: 5px;
        border: 1px solid #bbb;
    }

    input {
        border: 1px solid #bbb;
        padding: 2px;
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    h3 {
        margin: 0;
    }
</style>

<script>
export default {
    data () {
        return {
            username: '',
            password: '',
            rememberMe: false
        }
    },
        methods: {
        register () {
            const body = {
                name: this.username,
                password: this.password
            }
            this.$auth.login({
                url: process.env.API_URL + '/auth/register',
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: {name: 'Login'},
                success: (response) => {
                    console.log(response)
                },
                error: (error) => {
                    console.log(error)
                }
            })
        }
    },
    components: {
    }
}
</script>



// WEBPACK FOOTER //
// register.vue?084fd2fa